import { useParams } from 'react-router-dom'
import { RouteParams } from '@sketch/constants'
import { useVersioning } from 'modules/versioning'

/**
 * Returns the Artboard Detail pathname that maps to the currently viewed prototype
 * screen as defined by the current URL pathname.
 */
export function useArtboardDetailPathname() {
  const { permanentArtboardShortId, shareID } = useParams<
    RouteParams<'PROTOTYPE'>
  >()
  const { artboardUUID } = useParams<RouteParams<'PROTOTYPE_VIEW'>>()

  const { getPathname } = useVersioning()

  // @TODO Remove conditional when `prototype-manifest-file` FF is cleaned,
  // at that point PROTOTYPE view will no longer be used to display prototypes
  // and permanentArtboardShortId will never be defined
  return permanentArtboardShortId
    ? getPathname({
        routeKey: 'ARTBOARD_DETAIL',
        routeParams: {
          permanentArtboardShortId,
          shareID,
        },
      })
    : getPathname({
        routeKey: 'ARTBOARD_DETAIL_UUID',
        routeParams: {
          artboardUUID,
          shareID,
        },
      })
}
